export class AudienceSearchEditConfirm {
    constructor() {
        this.LastSavedUpdateDate = '';
        this.LastSavedUser = '';
        this.LastPublishedUpdateDate = '';
        this.LastPublishedUser = '';
        this.AudienceId = 0;
        this.DetailId = 0;
    }
}
//# sourceMappingURL=AudienceSearchEditConfirm.js.map